/**
 *
 *
 */

import { useEffect, useState } from 'react';
import { Content, Title, InputFormTable, Editor, Text } from 'components';
import { Select, Input, Radio, InputNumber, Space, Flex } from 'antd';

/**----------------------------------------
 * [Component] 총관리자: 상품등록 > 정기배송정보
 * ----------------------------------------
 */
const SalesInformation_regularInformation = ({ defaultValue, onChange }) => {
  /* ===== INITIAL ===== */

  /* ===== STATE ===== */
  const [data, setData] = useState(
    defaultValue
      ? defaultValue
      : {
          regular_postponed_deadline: 7, //미루기 가능 일 결제일로부터 N일전까지 가능 ex.) 3 -> 결제일로부터 3일전까지만 미루기 가능
          cancel_deadline: 7, //취소 가능 일 결제일로부터 N일전까지 가능 ex.) 3 -> 결제일로부터 3일전까지만 취소 가능
          regular_cycle: [
            // 주기-타입-미루기횟수(사용자가미룬횟수)
            /*   {
        label: '1주',
        value: '1-W-0',
      },
      {
        label: '2주',
        value: '2-W-0',
      },
      {
        label: '3주',
        value: '3-W-0',
      },
      {
        label: '4주',
        value: '4-W-0',
      },
      {
        label: '1개월',
        value: '1-M-0',
      },
      {
        label: '2개월',
        value: '2-M-0',
      },
      {
        label: '3개월',
        value: '3-M-0',
      }, */
          ],
          max_regular_delivery_count: '',
        }
  );

  /* ===== FUNCTION ===== */
  const onChangeData = (key, value) => {
    const newData = {
      ...data,
      [key]: value,
    };
    setData(newData);
    onChange(newData);
  };

  /* ===== HOOKS ===== */
  /* ===== VARIABLE ===== */

  /* ===== RENDER ===== */
  return (
    <>
      <Flex vertical gap={10}>
        <Space wrap>
          {/* 미루기 가능 일: regular_postponed_deadline */}
          <span>연기 가능날짜</span>
          <Select
            style={{
              width: 120,
            }}
            name="regular_postponed_deadline"
            value={data.regular_postponed_deadline}
            onChange={(value) =>
              onChangeData('regular_postponed_deadline', value)
            }
            options={[
              {
                value: 1,
                label: '1일',
              },
              {
                value: 3,
                label: '3일',
              },
              {
                value: 5,
                label: '5일',
              },
              {
                value: 7,
                label: '7일',
              },
            ]}
          />
          &nbsp;&nbsp;
          {/* 취소 가능 일 : cancel_deadline */}
          <span>취소 가능날짜</span>
          <Select
            style={{
              width: 120,
            }}
            name="cancel_deadline"
            value={data.cancel_deadline}
            onChange={(value) => onChangeData('cancel_deadline', value)}
            options={[
              {
                value: 1,
                label: '1일',
              },
              {
                value: 3,
                label: '3일',
              },
              {
                value: 5,
                label: '5일',
              },
              {
                value: 7,
                label: '7일',
              },
            ]}
          />
          &nbsp;&nbsp;
          {/* 주기-타입-미루기횟수(사용자가미룬횟수) : regular_cycle */}
          <span>배송주기</span>
          <Select
            mode="multiple"
            allowClear
            // defaultValue={null}
            style={{
              width: 340,
            }}
            name="regular_cycle"
            value={data.regular_cycle}
            onChange={(values, rows) => onChangeData('regular_cycle', rows)}
            // onChange={(values, rr) => console.log('rr: ', rr)}
            placeholder="배송주기"
            options={[
              // 주기-타입-미루기횟수(사용자가미룬횟수)
              {
                label: '1주',
                value: '1-W-0',
              },
              {
                label: '2주',
                value: '2-W-0',
              },
              {
                label: '3주',
                value: '3-W-0',
              },
              {
                label: '4주',
                value: '4-W-0',
              },
              {
                label: '1개월',
                value: '1-M-0',
              },
              {
                label: '2개월',
                value: '2-M-0',
              },
              {
                label: '3개월',
                value: '3-M-0',
              },
            ]}
          />
        </Space>

        <Flex vertical gap={5}>
          {/* 배송 횟수 */}
          <span>배송 가능 횟수</span>
          <Input
            name="max_regular_delivery_count"
            value={data.max_regular_delivery_count}
            onChange={(e) =>
              onChangeData('max_regular_delivery_count', e.target.value)
            }
            placeholder="선택 가능한 배송 횟수를 : 로 구분하여 입력해주세요. 예) 0:3:4:5:6"
          />
          <Text size={10} color={'#FF0000'}>
            0은 횟수에 상관없이 사용자가 중단하기 전까지 배송됨을 의미합니다.
          </Text>
        </Flex>
      </Flex>
    </>
  );
};

SalesInformation_regularInformation.defaultProps = {
  defaultValue: null,
  onChange: () => {},
};
export default SalesInformation_regularInformation;
